module.exports = __webpack_public_path__ + "img/mobielogo.a2414137.png";